export const PANEL_SWIPE_EXCLUSION_DATA_ATTRIBUTE = 'data-panel-swipe-exclusion'
export const PANEL_SWIPE_EXCLUSION_DATA_SELECTOR = `[${PANEL_SWIPE_EXCLUSION_DATA_ATTRIBUTE}="true"]`

export const PANEL_SWIPE_EXCLUSION_SELECTOR = [
    '[data-inline-editor-container="true"]',
    '[contenteditable="true"]',
    '[data-answer-interactive="true"]',
    'input',
    'label[for]',
    'textarea',
    'select',
    PANEL_SWIPE_EXCLUSION_DATA_SELECTOR,
].join(',')

export const panelSwipeExclusionProps = {
    [PANEL_SWIPE_EXCLUSION_DATA_ATTRIBUTE]: 'true',
}
